<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Select } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'];

	const viewOptions = [
		{
			title: capFirstChar(
				$format('virtual_component_label_button', {
					default: 'button',
				}),
			),
			value: 'button',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_hidden', {
					default: 'hidden',
				}),
			),
			value: '',
		},
	];
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_view', {
		default: 'View',
	})}
</Text>
<Select
	aria-label={$format('select_view', { default: 'Select view' })}
	class="width-full mb-m"
	value={viewOptions.find((i) => i.value == settings?.meta?.ui.view) || viewOptions[0]}
	options={viewOptions}
	icon="fas fa-eye"
	on:change={(e) => {
		settings.meta.ui.view = e.detail['value'];
	}}
	id="select-sdvbb0d"
/>
